<ng-container *ngIf="activeStep !== -1">
  <ui-progress-tracker
    [steps]="stepLabel"
    [activeStep]="activeStep"
  ></ui-progress-tracker>
</ng-container>
